export const BACKEND_PERSONAL_INFO_KEY = 'PersonalInfo';
export const BACKEND_EDUCATION_LIST_KEY = 'EducationTypeOptions';
export const BACKEND_EDUCATION_GOALS_KEY = 'EducationGoals';
export const BACKEND_EDUCATION_GOAL_API = 'EducationGoal';
export const OTHER_TUITION = 5;
